import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import useFlags from '@/hooks/useFlags';
import ReactSelect5, { Option } from '@/components/common/ReactSelect5';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import { gradingNavigationStringParams } from '@/components/staffer/Grading/utils';
import ArrowNavigator from './ArrowNavigator';
import BulkGradingButton from './BulkGradingButton';

const QuestionNavigator = () => {
  const assignment = useGradingStore(state => state.assignment);
  const questionId = useGradingStore(state => state.questionId);
  const setGradingStore = useGradingStore(state => state.setGradingStore);
  const { aiGradingActive } = useFlags();

  const { question_data_for_navigation: questionData, questions } = assignment;
  const navigate = useNavigate();

  const [currentQuestion, setCurrentQuestion] = useState<Option>(null);

  const navigableOptions = [];
  const dropdownOptions = [];
  questionData.forEach((question) => {
    const questionOption: Option = {
      className: question.disabled ? 'tw-font-bold !tw-text-very-dark-grey' : '',
      isDisabled: question.disabled,
      label: question.label,
      value: question.value.toString(),
    };
    if (!question.disabled) navigableOptions.push(questionOption);
    dropdownOptions.push(questionOption);
  });

  useEffect(() => {
    const question = questions.find(q => q.id === questionId);
    setCurrentQuestion({
      label: `${question.body.substring(0, 30)}...`,
      value: question.id.toString(),
    });
  }, [questionId, questions]);

  const onQuestionChange = (value: string) => {
    const newQuestionId = parseInt(value, 10);
    setGradingStore({ questionId: newQuestionId });
    navigate(`/${assignment.id}/questions/${newQuestionId}?${gradingNavigationStringParams()}`);
  };

  const label = 'Question';
  const toggleId = 'question-toggle';

  return (
    <div className="tw-flex tw-flex-col tw-items-end">
      <ArrowNavigator
        currentValue={questionId.toString()}
        isDisabled={navigableOptions.length <= 1}
        label={label}
        labelClass="tw-text-xs"
        navigableOptions={navigableOptions}
        toggleId={toggleId}
        onChange={onQuestionChange}
      >
        <ReactSelect5
          classNames={{ option: (state: any) => state.data.className || '' }}
          id={toggleId}
          options={dropdownOptions}
          value={currentQuestion}
          onChange={(opt: Option) => onQuestionChange(opt.value)}
        />
      </ArrowNavigator>
      <div className="tw-mr-6">
        {!aiGradingActive && <BulkGradingButton />}
      </div>
    </div>
  );
};

export default QuestionNavigator;
